import React from 'react'
import PropTypes from 'prop-types'
import { Button, MenuItem } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { Link } from 'react-router-dom'
import ButtonDropdownStyles from './ButtonDropdownStyles'

const ButtonDropdown = ({ label = 'Options', items = [] }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleClick = (event) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)

  return (
    <>
      <Button
        variant="contained"
        disableElevation
        endIcon={<KeyboardArrowDownIcon />}
        onClick={handleClick}
      >
        {label}
      </Button>

      <ButtonDropdownStyles anchorEl={anchorEl} open={open} onClose={handleClose}>
        {items.map((it, idx) => {
          if (it?.href) {
            return (
              <MenuItem
                key={idx}
                component={Link}
                to={it.href}
                onClick={handleClose}
                disableRipple
                sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
              >
                {it?.icon}
                {it?.label}
              </MenuItem>
            )
          }

          return (
            <MenuItem
              key={idx}
              onClick={() => {
                it?.onClick?.()
                handleClose()
              }}
              disableRipple
              sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
            >
              {it?.icon}
              {it?.label}
            </MenuItem>
          )
        })}
      </ButtonDropdownStyles>
    </>
  )
}

ButtonDropdown.propTypes = {
  label: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      icon: PropTypes.node,
      onClick: PropTypes.func,
    }),
  ),
}

export default ButtonDropdown
